const arrayTags = [
  'acessórios para berço',
  'acessórios',
  'almofadas',
  'banho',
  'body',
  'calçados e acessórios',
  'cobertores e mantas',
  'conjuntos',
  'decoração',
  'fantasias',
  'fraldas',
  'higiene',
  'kit berço',
  'kit bolsa',
  'macacão',
  'mamadeiras',
  'meias',
  'mijão',
  'mosqueteiros e acessórios',
  'ninho',
  'organizadores',
  'pagão',
  'roupas',
  'saída de maternidade',
  'temáticos',
  'toucas e luvas',
];

export default arrayTags;
